// Where each published data file lives when the data is served inside the prerendered pages
// (scripts/prerender.mjs) instead of as JSON files. Plain module with explicit extensions: the prerender
// script imports it from Node.

import { groupsIndexPath, symbolsPath } from "./paths.js";

/** Id of the `<script type="application/json">` holding a page's data, keyed by data path. */
export const PAGE_DATA_ID = "page-data";

/**
 * Page of a group (`id`: e.g. sectors/Technology, industries/Technology__Semiconductors, indexes/snp500).
 * Industry ids join the sector and industry slugs with `__`, which a slug never contains.
 */
export const groupPagePath = (id) => {
  const [kind, name] = id.split("/");
  if (id === "indexes/market") return "/market";
  if (kind === "indexes") return `/indexes/${name}`;
  if (kind === "sectors") return `/sectors/${name}`;
  if (kind === "industries") {
    const [sector, industry] = name.split("__");
    return `/sectors/${sector}/industries/${industry}`;
  }
  return null;
};

/** Page of stock list page `page` (1-based). */
export const stocksPagePagePath = (page) => (page === 1 ? "/stocks" : `/stocks/page/${page}`);

/**
 * Page that carries the data file `path` (see ./paths.js), or null when no page does.
 */
export const dataPagePath = (path) => {
  if (path === symbolsPath()) return "/stocks";
  if (path === groupsIndexPath()) return "/sectors";
  let match = path.match(/^market\/list\/stocks-page-(\d+)\.json$/);
  if (match) return stocksPagePagePath(Number(match[1]));
  match = path.match(/^bundles\/stocks\/(.+)\.json$/);
  if (match) return `/stocks/${match[1]}`;
  match = path.match(/^bundles\/groups\/(.+)\.json$/);
  if (match) return groupPagePath(match[1]);
  return null;
};
